var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imprint)?_c('section',{attrs:{"id":"single-page"}},[_c('BaseBasicPage',{attrs:{"page-content":_vm.imprint}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }